module.exports = __webpack_public_path__ + "img/error-accessories.029410ce.svg";